module.exports = __webpack_public_path__ + "img/bgc15.800b05ec.png";